import React from 'react';
import { Typography, Button, Wrapper, Image } from '../../ui';
import donateImg from '../../../images/donate.png';

const Donate = ({ handleBack, handleNext }) => {
  return (
    <Wrapper>
      <Image width={100} center src={donateImg} alt="Donate us" />
      <Typography variant="h2" mb={2} mt={3} align="center">
        Keep us Alive!
      </Typography>
      <Typography variant="h3" mb={1} align="center">
        Donate to this Free Open Source Project.
      </Typography>

      <Wrapper display="flex" justifyContent="center" mt={4}>
        <Button
          target="_blank"
          href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=HWB6ZGT2NKNQJ"
          color="primary"
          variant="contained"
        >
          Donate Now
        </Button>
      </Wrapper>

      <Wrapper display="flex" justifyContent="space-between" mt={8}>
        <Button variant="outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          onClick={handleNext}
          variant="contained"
          color="secondary"
          type="submit"
        >
          Skip To Download Now
        </Button>
      </Wrapper>
    </Wrapper>
  );
};

export default Donate;
